import {useConsumerMenu} from "../context/MenuContext";
import React from "react";
import {IconHome} from "../../../../bounce-ui/assets";
import {useNavigate} from "react-router-dom";
import {urls} from "../../../../routes/urls";
import CustomMenuItem from "../../../../components/menus/CustomMenuItem";

const HomeMenuItem = () => {
  const {trackAndCloseMenu} = useConsumerMenu();
  const navigate = useNavigate();

  const onHomeClickButton = () => {
    trackAndCloseMenu("home");
    navigate(urls.accounts.url);
  };

  return <CustomMenuItem onClick={onHomeClickButton} label="Home" icon={<IconHome width={20} height={20} />} />;
};

export default HomeMenuItem;
